import React from 'react';
import { LandingPageProvider, PageContent } from '@ruggable/ecomm-design-guide';
import siteConfig from '../../scripts/utils/configs/site-config';
import { getActiveCurrency } from '../../scripts/utils/locale';
import { userSession } from '../utils/userSession';

const chooseHandle = (userProfile, pathname) => {
  if (pathname) {
    if (pathname === '/search') {
      return 'search';
    }
    const [, , handle] = pathname.split('/');
    return handle;
  }

  const segment = userProfile && userProfile.segment === 'interested' ? 'interested' : 'new';
  switch (localStorage.contentful_locale) {
    case 'en-CA':
    case 'en-US': {
      return `rebrand-home-${segment}-user`;
    }
    case 'en-AU': {
      return 'rebrand-home-new-user-au';
    }
    case 'de-DE': {
      return 'rebrand-home-new-user-de';
    }
    case 'en-GB': {
      return 'rebrand-home-new-user-uk';
    }
    default: {
      return 'rebrand-home-new-user';
    }
  }
};

const pathnameToContentType = (pathname) => {
  const [, prefix] = pathname.split('/');

  if (prefix === 'collections') {
    return 'productCollection';
  }

  return 'page';
};

const DesignGuidePage = () => {
  const defaultCurrency = getActiveCurrency();

  const defaultLocale = window.Shopify?.currency?.active === 'CAD' ? 'en-CA' : window.ruggableStorefrontProps.defaultLocale;

  const [userProfile] = React.useState(() => userSession.userProfile);

  const pathname = window.location.pathname && window.location.pathname.replace(/\/$/, '');
  const handle = chooseHandle(userProfile, pathname);
  const contentType = pathnameToContentType(pathname);

  return (
    <LandingPageProvider defaultCurrency={defaultCurrency} defaultLocale={defaultLocale} config={siteConfig}>
      <PageContent contentType={contentType} handle={handle} defaultLocale={defaultLocale} />
    </LandingPageProvider>
  );
};

export default DesignGuidePage;
